import { DocumentTextIcon } from '@/components/icons/DocumentTextIcon'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTriangleIcon,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'
import type { ToolReferenceDocument } from '@/services/queries/tools'
import { OpenInNewWindowIcon } from '@radix-ui/react-icons'

export const References = ({
  references,
}: {
  references: ToolReferenceDocument[]
}) => {
  return (
    <div className="ml-2 max-h-52 overflow-scroll">
      {references.map((doc) => (
        <Collapsible key={doc.id} className="mt-2">
          <div className="flex items-center">
            <CollapsibleTrigger>
              <button className="flex items-center">
                <CollapsibleTriangleIcon className="w-5 h-5 text-indigo-400" />
                <DocumentTextIcon className="w-4 stroke-gray-800 mr-1" />
                <span>{doc.name}</span>
              </button>
            </CollapsibleTrigger>
            <a
              href={`/p/${doc.projectId}/document/${doc.id}/edit`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <OpenInNewWindowIcon className="text-blue-500 ml-1" />
            </a>
          </div>
          <CollapsibleContent>
            <ul>
              {doc.pages.map((page) => (
                <li key={page.id} className="ml-6 mt-1">
                  <div className="inline-block">
                    <a
                      href={`/p/${doc.projectId}/document/${doc.id}/edit?page_id=${page.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-blue-500"
                    >
                      <span>{page.name}</span>
                      <OpenInNewWindowIcon className="ml-1" />
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </CollapsibleContent>
        </Collapsible>
      ))}
    </div>
  )
}
